import {gql} from '@apollo/client';

export const CHECK_WS_CONNECTION_QUERY = gql`
query ($clientId: String!) {
    checkWSConnectionQuery(clientId: $clientId)
}
`